<template>
  <div class="container">
    <div>
      <h1>404</h1>
      <h2>访问地址不正确</h2>
      <!-- <p>Not the correct URL。</p> -->
      <el-button type="primary" @click="goToPage" class="login_button"
        >回到首页</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goToPage() {
      // top.location.href = process.env.VUE_APP_home;
      top.location.href = window.location.origin
    },
  },
};
</script>
<style  scoped>
.container {
  padding-top: 20%;
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
h1 {
  font-size: 100px;
  margin: 15px 0px;
  font-weight: bold;
}
p {
  width: 100%;
  margin-top: 10px;
}
button {
  margin-top: 20px;
}
.login_button {
  background: #000;
  border-color: #000 !important;
}
</style>